import style from "./App.module.scss";
import { Header } from "./components/Header/Header";
import { MainPage } from "./components/MainPage/MainPage";
import { Footer } from "./components/Footer/Footer";
import { Article } from "./components/Article/Article";
import { article, home } from "./routes";
import { ColorContext } from "./ColorContext";
import { CSSProperties, useRef, useState } from "react";
import { AnchorContext } from "./AnchorContext";

const Home = home(MainPage);
const ArticlePage = article(Article);

function App() {
  const [color, setColor] = useState<CSSProperties["backgroundColor"]>();
  const [anchor, setAnchor] = useState("");

  return (
    <AnchorContext.Provider value={{ anchor, setCurrentAnchor: (newAnchor: string) => {
      if(newAnchor !== anchor){

        setAnchor(newAnchor)
      }
    } }}>
    <ColorContext.Provider value={{ color, setColor }}>
      <div className="App">
        <Header />
        <Home />
        {/*//@ts-ignore */}
        <ArticlePage />
        <Footer />
      </div>
    </ColorContext.Provider>
    </AnchorContext.Provider>
  );
}

export default App;
